import { render, staticRenderFns } from "./BaseChipCollection.vue?vue&type=template&id=7ae14a86&scoped=true&"
import script from "./BaseChipCollection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseChipCollection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseChipCollection.vue?vue&type=style&index=0&id=7ae14a86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae14a86",
  null
  
)

export default component.exports